// extracted by mini-css-extract-plugin
export default {"fullBorder":"inputStyle_fullBorder__iYIZz","plain":"inputStyle_plain__x5dwf","plain_value":"inputStyle_plain_value__5N0mh","fullBorder_value":"inputStyle_fullBorder_value__uberP"};